
import { useStore } from '../stores/store';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

export const RequiredAuth = () => {
    const { userStore: { isLoggedIn, user } } = useStore();
    const location = useLocation();

    if (!isLoggedIn || !user) {
        return <Navigate to="/" state={{ from: location }} />
    }

    return <Outlet />
}
